export default __webpack_public_path__ + "media/images/mailer-new/heading/reaction-68f07737051ed9a28f0b2d1a819dc84f.png";